($ => {

    /**
     * Delegado: a navegação do site (page-nav.js) troca o <main> sem recarregar, então botões data-modal
     * novos (ex.: Mais filtros do catálogo) precisam do listener no document.
     */
    $(document).on("click", "[data-modal]", function (e) {
        e.preventDefault();
        const selector = String($(this).attr("data-modal") || $(this).data("modal") || "").trim();
        if (!selector) {
            return;
        }
        const dialog = document.querySelector(selector);
        if (!(dialog instanceof HTMLDialogElement) || typeof dialog.showModal !== "function") {
            return;
        }
        if (dialog.open) {
            return;
        }
        try {
            dialog.showModal();
            jQuery(dialog).trigger("opened");
        } catch (_error) {
            dialog.setAttribute("open", "");
            jQuery(dialog).trigger("opened");
        }
    });

    /**
     * Clique no fundo (backdrop) fecha o modal — só se o clique também COMEÇOU no fundo. Quando o
     * botão é pressionado dentro do modal e solto fora (ex.: escolher um item de uma lista suspensa
     * que fecha no pressionar, como o AvatarSelect, ou arrastar uma seleção de texto), o navegador
     * dispara o click no ancestral comum — o próprio <dialog> — e o modal fechava sozinho.
     */
    let pressionadoNoFundo = null;
    $(document).on("pointerdown", "dialog", function (event) {
        pressionadoNoFundo = event.target === this ? this : null;
    });

    $(document).on("click", "dialog", function (event) {
        if (event.target !== this || pressionadoNoFundo !== this) {
            return;
        }
        $(this).close();
    });

    $(document).on("opened", "dialog", function () {
        if ($(this).find(".rich-text-editor").length) {
            $(this).append($(".tox-tinymce-aux"));
        }
    });

    $(document).on("closed", "dialog", function () {
        if ($(this).find(".rich-text-editor").length) {
            $("body").append($(".tox-tinymce-aux"));
        }
    });

    $(document).on("click", "dialog .btn-close-modal", function (event) {
        event.preventDefault();
        $(event.currentTarget).closest("dialog").close();
    });

})(jQuery);
